module.exports = __webpack_public_path__ + "static/media/sweet_view_6.9d4b77b4.jpg";